import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cmsApi } from '../api';
import { useCity } from '../context/CityContext';
import { useSiteSettings } from '../context/SiteSettingsContext';
import './Footer.css';

export default function Footer() {
  const { selectedCity } = useCity();
  const { blogEnabled } = useSiteSettings();
  const [areas, setAreas]             = useState([]);
  const [areasLoaded, setAreasLoaded] = useState(false);

  useEffect(() => {
    setAreasLoaded(false);
    cmsApi.getAreas(selectedCity || '')
      .then(data => {
        // Take top 5 by place count (API already orders by count DESC),
        // then sort those 5 alphabetically for the footer display.
        const top5 = data
          .slice(0, 5)
          .sort((a, b) => a.name.localeCompare(b.name));
        setAreas(top5);
        setAreasLoaded(true);
      })
      .catch(() => setAreasLoaded(true));
  }, [selectedCity]);

  return (
    <footer>
      <div className="ft-inner">
        <div className="ft-grid">
          <div className="ft-brand">
            <img src="/logo-white.png" alt="Zénde" style={{ height: 28, width: 'auto', marginBottom: 8 }} />
            <p>The go-to guide for Nigeria's most vibrant cities — places, events and activities, curated and verified.</p>
            <div className="ft-socials">
              <a href="https://instagram.com/zendehq" target="_blank" rel="noreferrer">Instagram</a>
            </div>
          </div>

          <div>
            <div className="ft-heading">Explore</div>
            <Link to="/places">Places</Link>
            <Link to="/events">Events</Link>
            <Link to="/activities">Activities</Link>
            {/* ITINERARY_DISABLED <Link to="/plan">Plan a trip</Link> */}
            {blogEnabled && <Link to="/blog">Blog</Link>}
          </div>

          <div>
            <div className="ft-heading">
              {selectedCity ? `${selectedCity} Areas` : 'Areas'}
            </div>
            {!areasLoaded
              ? <span style={{ fontSize: 11, color: 'rgba(255,255,255,.3)' }}>Loading…</span>
              : areas.length > 0
                ? areas.map(a => (
                    <Link key={a.id ?? a.name} to={`/places?area=${encodeURIComponent(a.name)}`}>
                      {a.name}
                    </Link>
                  ))
                : <span style={{ fontSize: 11, color: 'rgba(255,255,255,.3)' }}>—</span>
            }
          </div>

          <div>
            <div className="ft-heading">Zénde</div>
            <Link to="/privacy">Privacy policy</Link>
            <Link to="/terms">Terms of use</Link>
          </div>
        </div>

        <div className="ft-bottom">
          <span>© {new Date().getFullYear()} Zénde</span>
          <span>zende.ng{selectedCity ? ` · ${selectedCity}` : ''}</span>
        </div>
      </div>
    </footer>
  );
}
